/**
 * Initial Fee Manager
 * サブスク商品（GO SUB）をカートに追加した際に、
 * 対応する初期費用バリアントを自動でカートに追加するロジック。
 *
 * 依存: theme.cart.getCart, theme.routes (cartAdd, cartChange)
 * イベント: ajaxProduct:added (theme.js L2785), cart:updated (theme.js L1788)
 * プロパティ: _initial_fee_for (cart-item.liquid で _ 接頭辞により非表示)
 *
 * 商品ページ（cartType=page）ではフォーム送信をインターセプトし、
 * サブスク商品＋初期費用を同時にAJAXで追加してからカートへリダイレクトする。
 *
 * 逆方向（初期費用商品ページ起点）: data-initial-fee-subscription-map がある場合、
 * 初期費用＋対応する月額商品（selling_plan つき）を同時に追加する。
 * カート上の紐付け（_initial_fee_for）は同じなので、整合性チェックはそのまま共通。
 */
(function() {
  'use strict';

  var PROPERTY_KEY = '_initial_fee_for';

  // 重複・順序・空文字を無視して、ID の集合が同じか
  function sameIds(a, b) {
    var normalize = function(ids) {
      return ids.filter(function(id, i) {
        return id && ids.indexOf(id) === i;
      }).sort().join(',');
    };
    return normalize(a) === normalize(b);
  }

  var InitialFeeManager = {
    _isApplyingChanges: false,

    /**
     * 初期化
     */
    init: function() {
      document.addEventListener('ajaxProduct:added', this._onProductAdded.bind(this));
      document.addEventListener('cart:updated', this._onCartUpdated.bind(this));
      this._interceptProductForm();
      this._interceptFeeProductForm();
      this._runConsistencyCheck();
    },

    // ================================================================
    //  初期費用商品ページでのフォーム送信インターセプト
    //  初期費用バリアントに対応する月額バリアントを selling_plan つきで同時追加。
    // ================================================================

    _interceptFeeProductForm: function() {
      var mapEl = document.querySelector('[data-initial-fee-subscription-map][data-form-id]');
      if (!mapEl) return;

      var form = document.getElementById(mapEl.getAttribute('data-form-id'));
      if (!form) return;

      var subMap;
      try { subMap = JSON.parse(mapEl.textContent); }
      catch (e) { return; }

      console.log('[InitialFeeManager] intercepting initial fee form submit');

      var self = this;
      form.addEventListener('submit', function(evt) {
        var formData = new FormData(form);
        var feeVariantId = formData.get('id');
        // 数量欄の数だけ契約する（月額・初期費用とも同じ数）
        var quantity = parseInt(formData.get('quantity'), 10) || 1;
        var sub = subMap[String(feeVariantId)];
        // 対応する月額バリアントが無い → 通常のPOST送信に任せる
        if (!sub) {
          console.log('[InitialFeeManager] no subscription mapping for fee variant', feeVariantId);
          return;
        }

        evt.preventDefault();
        console.log('[InitialFeeManager] intercepted fee submit: fee=' + feeVariantId +
          ', subscription=' + sub.id + ', selling_plan=' + sub.selling_plan);

        self._addSubscriptionWithFee(form, sub.id, sub.selling_plan, feeVariantId, quantity);
      });
    },

    // ================================================================
    //  商品ページでのフォーム送信インターセプト
    //  cartType=page の場合、通常のPOSTだと初期費用が追加されない。
    //  フォーム送信をキャッチしてAJAXで2アイテム同時追加→カートへリダイレクト。
    // ================================================================

    _interceptProductForm: function() {
      var form = document.querySelector('.product-single__form--subscription');
      if (!form) return;

      var feeMap = this._getFeeMapFromProductForm();
      if (!feeMap) return;

      console.log('[InitialFeeManager] intercepting subscription form submit');

      var self = this;
      form.addEventListener('submit', function(evt) {
        var formData = new FormData(form);
        var variantId = formData.get('id');
        var sellingPlan = formData.get('selling_plan');

        // selling_plan が無い＝通常購入 → 初期費用不要、通常のPOST送信に任せる
        if (!sellingPlan) {
          console.log('[InitialFeeManager] no selling_plan, allowing normal submit');
          return;
        }

        var feeVariantId = feeMap[String(variantId)];
        // このバリアントに初期費用マッピングが無い → 通常のPOST送信に任せる
        if (!feeVariantId) {
          console.log('[InitialFeeManager] no fee mapping for variant', variantId);
          return;
        }

        // ここからAJAX送信に切り替え
        evt.preventDefault();
        console.log('[InitialFeeManager] intercepted submit: variant=' + variantId +
          ', selling_plan=' + sellingPlan + ', fee=' + feeVariantId);

        // 数量欄の数だけ契約する（月額・初期費用とも同じ数）
        var quantity = parseInt(formData.get('quantity'), 10) || 1;
        self._addSubscriptionWithFee(form, variantId, sellingPlan, feeVariantId, quantity);
      });
    },

    /**
     * 月額（selling_plan つき）＋初期費用を同時にカートへ追加し、カートページへ移動する（月額ページ・初期費用ページ共通）。
     * 片方だけのカートにしないため、失敗時（在庫切れ・通信エラー等すべて）は追加せずに案内する。
     * quantity: 契約数（月額・初期費用とも同じ数。1契約につき初期費用1回）
     */
    _addSubscriptionWithFee: function(form, subVariantId, sellingPlanId, feeVariantId, quantity) {
      // ボタンを無効化してフィードバック
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var btnTextEl = submitBtn && submitBtn.querySelector('[data-add-to-cart-text]');
      var originalText = btnTextEl ? btnTextEl.textContent : '';
      if (submitBtn) submitBtn.disabled = true;
      if (btnTextEl) btnTextEl.textContent = 'カートに追加中...';

      var items = [
        {
          id: parseInt(subVariantId),
          quantity: quantity,
          selling_plan: parseInt(sellingPlanId)
        },
        {
          id: parseInt(feeVariantId),
          quantity: quantity,
          properties: {}
        }
      ];
      items[1].properties[PROPERTY_KEY] = String(subVariantId);

      this._postJSON(theme.routes.cartAdd, { items: items })
        .then(function() {
          window.location.href = '/cart';
        })
        .catch(function(err) {
          console.error('[InitialFeeManager] Cart add error:', err);
          // エラー時はボタンを復元
          if (submitBtn) submitBtn.disabled = false;
          if (btnTextEl) btnTextEl.textContent = originalText;
          window.alert('カートに追加できませんでした。時間をおいて再度お試しください。');
        });
    },

    // ================================================================
    //  商品追加時（ajaxProduct:added）
    // ================================================================

    /**
     * 商品追加時のハンドラ
     * evt.detail.product は cart/add.js のレスポンス（line item）
     */
    _onProductAdded: function(evt) {
      var product = evt.detail && evt.detail.product;
      console.log('[InitialFeeManager] ajaxProduct:added fired', product);
      if (!product) return;

      var variantId = String(product.variant_id || product.id);

      // サブスク商品かどうか（selling_plan_allocation があるか）
      console.log('[InitialFeeManager] selling_plan_allocation:', product.selling_plan_allocation);
      if (!product.selling_plan_allocation) {
        console.log('[InitialFeeManager] → not a subscription item, skipping');
        return;
      }

      // data-initial-fee-map からマッピングを取得
      var feeMap = this._getFeeMapFromProductForm();
      console.log('[InitialFeeManager] feeMap:', feeMap);
      if (!feeMap) {
        console.log('[InitialFeeManager] → no fee map found, skipping');
        return;
      }

      var feeVariantId = feeMap[variantId];
      console.log('[InitialFeeManager] variantId:', variantId, '→ feeVariantId:', feeVariantId);
      if (!feeVariantId) return;

      this._addFeeIfNeeded(variantId, feeVariantId);
    },

    // ================================================================
    //  カート更新時（cart:updated）
    //  theme.js の quantityChanged() から発火。
    //  evt.detail.cart に最新の cart JSON が入っている。
    //
    //  重要: cart:updated は buildCart() の fetch 完了前に同期発火する。
    //  しかし evt.detail.cart は changeItem() の戻り値（最新の cart JSON）
    //  なので、DOM を待たなくても cart API だけで整合性チェックできる。
    //  data-cart-fee-map（DOM）は使わず、cart JSON のメタ情報で判定する。
    // ================================================================

    _onCartUpdated: function(evt) {
      if (this._isApplyingChanges) return;

      var cart = evt.detail && evt.detail.cart;
      if (!cart) return;

      var self = this;

      // 先に cart JSON だけで整合性チェック（孤立した初期費用の削除・数量補正）を行う。
      // fee-map は DOM（data-cart-fee-map）からではなく、cart/add 時に付与した
      // _initial_fee_for プロパティだけで孤立判定・数量補正を行う。
      // 「不足している初期費用の追加」は buildCart 後の DOM から fee-map を読む必要があるが、
      // それは _runConsistencyCheck（ページ読込時）に任せる。
      // 月額の数量を増やしたときに、補正前の状態で「初期費用が足りない」と判定して再読込し、補正後にもう一度再読込しないよう、
      // 補正が反映されたら _applyChanges の再読込1回だけにする。
      var hasSubscription = cart.items.some(function(item) {
        return !!item.selling_plan_allocation;
      });
      var hasFeeItem = cart.items.some(function(item) {
        return item.properties && item.properties[PROPERTY_KEY];
      });
      var pending = (hasSubscription || hasFeeItem) ? this._ensureConsistencyFromCart(cart) : null;
      if (pending) {
        // 補正が終わるまでは、初期費用が足りないまま購入手続きに進めないよう止めておく
        this._lockCheckout();
        // 反映できれば _applyChanges が再読込する。1件も反映できなかった（在庫切れ等）場合も、
        // 止めたボタンを戻し、チェックアウト停止の表示をサーバーの判定に合わせるため再読込する
        // （ここはお客様の数量操作のときだけ動き、再読込後のチェックは失敗しても再読込しないため繰り返さない）
        pending.then(function(changed) {
          if (!changed && document.getElementById('CartPageForm')) window.location.reload();
        });
        return;
      }

      this._reloadIfCheckoutBlockChanged(cart);
    },

    /**
     * カートページの購入手続きを一時的に止める（初期費用の数量補正中）。
     * 購入ボタンは disabled にする（同意欄の CSS の pointer-events に上書きされない）。
     * アプリの購入ボタン・エクスプレス決済は、main-cart.liquid のチェックアウト停止と同じく隠す。
     * 戻すときは再読込するので、解除の処理は持たない
     */
    _lockCheckout: function() {
      var form = document.getElementById('CartPageForm');
      if (!form) return;
      var btn = document.getElementById('checkout-btn');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('btn--loading');
      }
      Array.prototype.forEach.call(form.querySelectorAll('.tpo-btn-checkout, .additional-checkout-buttons'), function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    },

    /**
     * チェックアウトを止める原因（未紐付けの初期費用行・初期費用の無い月額行）が表示中の状態から変わったら再読込する。
     * cart:build（cart.ajax）は商品一覧と合計しか描き直さず、ボタン・案内文が古いまま残るため。
     * 解除されたとき → 制限を外す／初期費用の行だけが削除されたとき → main-cart.liquid が止め、_ensureConsistencyFull が補う。
     * 変わっていなければ再読込しない（ブロック中に他の行を操作しても、毎回は再読込しない）。
     */
    _reloadIfCheckoutBlockChanged: function(cart) {
      if (this._isCheckoutBlockChanged(cart)) {
        window.location.reload();
      }
    },

    /**
     * cart JSON のみで整合性チェック（DOM不要・軽量版）
     * - 孤立した初期費用の削除
     * - 数量を月額の数量に合わせる補正
     * ※ 不足追加は行わない（buildCart 後の DOM 版で対応）
     * 戻り値: 変更がある場合は _applyChanges の Promise（反映できたら true）、無ければ null
     */
    _ensureConsistencyFromCart: function(cart) {
      var subscriptionVariantIds = [];
      var feeItems = [];
      var changes = [];

      cart.items.forEach(function(item) {
        if (item.selling_plan_allocation) {
          subscriptionVariantIds.push(String(item.variant_id));
        }
        if (item.properties && item.properties[PROPERTY_KEY]) {
          feeItems.push(item);
        }
      });

      // 孤立した初期費用を削除（付随するアドオン行も）
      var self = this;
      feeItems.forEach(function(feeItem) {
        var linkedId = feeItem.properties[PROPERTY_KEY];
        if (subscriptionVariantIds.indexOf(String(linkedId)) === -1) {
          changes.push({ key: feeItem.key, quantity: 0, action: 'remove_orphan' });
          changes = changes.concat(self._addonRemovals(cart, feeItem));
        }
      });

      // 数量補正（初期費用は月額の数量と同じ数だけ必要）
      changes = changes.concat(this._quantityFixes(cart, feeItems, this._subscriptionQuantities(cart)));

      return changes.length > 0 ? this._applyChanges(changes) : null;
    },

    // ================================================================
    //  ページ読込時の整合性チェック（DOM の data-cart-fee-map を使用）
    //  不足している初期費用の追加もここで行う
    // ================================================================

    _runConsistencyCheck: function() {
      var self = this;
      var run = function() {
        console.log('[InitialFeeManager] consistency check running');
        var cartFeeMap = self._getCartFeeMap();
        console.log('[InitialFeeManager] cartFeeMap:', cartFeeMap);
        var feeMapEl = document.querySelector('[data-cart-fee-map]');
        console.log('[InitialFeeManager] data-cart-fee-map element:', feeMapEl, 'content:', feeMapEl ? feeMapEl.textContent : 'N/A');
        if (!cartFeeMap) {
          console.log('[InitialFeeManager] → no cart fee map, skipping');
          return;
        }

        theme.cart.getCart().then(function(cart) {
          console.log('[InitialFeeManager] cart items:', cart.items.length, cart.items.map(function(i) { return i.title + ' (variant:' + i.variant_id + ', selling_plan:' + !!i.selling_plan_allocation + ')'; }));
          return self._attachMissingSubscriptions(cart);
        }).then(function(cart) {
          self._ensureConsistencyFull(cart, cartFeeMap);
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        setTimeout(run, 500);
      }
    },

    /**
     * 初期費用だけがカートにある場合に、対応する月額商品を補完する。
     * 組立オプション等のアプリが商品ページの送信を独自処理する商品では
     * _interceptFeeProductForm が動かないため、カートページで追加する。
     * 初期費用行には _initial_fee_for を既存プロパティにマージして付与し、以降は通常の整合性チェックに乗せる。
     * 戻り値: 最新の cart JSON
     */
    _attachMissingSubscriptions: function(cart) {
      var subMap = this._getCartSubscriptionMap();
      if (!subMap) return Promise.resolve(cart);

      var targets = cart.items.filter(function(item) {
        return !(item.properties && item.properties[PROPERTY_KEY]) && subMap[String(item.variant_id)];
      });
      if (targets.length === 0) return Promise.resolve(cart);

      var self = this;
      var changed = false;
      var chain = Promise.resolve();
      targets.forEach(function(feeItem) {
        var sub = subMap[String(feeItem.variant_id)];
        chain = chain.then(function() {
          return theme.cart.getCart();
        }).then(function(latest) {
          // 前回、月額の追加後に紐付けだけ失敗していた場合は、未紐付けの月額行が残っている。
          // 追加し直すと数量が2になるため、紐付けだけをやり直す。
          if (self._hasUnlinkedSubscription(latest, sub.id, sub.selling_plan)) {
            console.log('[InitialFeeManager] subscription ' + sub.id + ' already in cart, linking only');
            return;
          }
          console.log('[InitialFeeManager] attaching subscription ' + sub.id + ' to fee ' + feeItem.variant_id);
          return self._postJSON(theme.routes.cartAdd, {
            items: [{ id: parseInt(sub.id), quantity: feeItem.quantity, selling_plan: parseInt(sub.selling_plan) }]
          }).then(function() { changed = true; });
        }).then(function() {
          var properties = {};
          Object.keys(feeItem.properties || {}).forEach(function(k) {
            properties[k] = feeItem.properties[k];
          });
          properties[PROPERTY_KEY] = String(sub.id);
          return self._postJSON(theme.routes.cartChange, { id: feeItem.key, quantity: feeItem.quantity, properties: properties });
        }).then(function() { changed = true; });
      });

      return chain.then(function() {
        // cart:build（cart.ajax）だと同意欄・アドオン非表示が再描画されないため、ページごと再読込する。
        // 再読込後は初期費用行に紐付けがあるので再実行されない。
        window.location.reload();
        return new Promise(function() {});
      }).catch(function(err) {
        console.warn('[InitialFeeManager] Failed to attach subscription:', err);
        // 途中まで反映された場合（月額の追加だけ成功など）は表示を合わせるため再読込する。
        // 次回は未紐付けの月額行があるので紐付けのみ再試行し、それも失敗すればカートは変わらず再読込されない。
        if (changed) {
          window.location.reload();
          return new Promise(function() {});
        }
        return theme.cart.getCart();
      });
    },

    /**
     * 月額バリアント（指定の定期購入プラン）の行のうち、どの初期費用行からも紐付けられていないものがあるか。
     * プランが異なる行は請求条件が違うため対象外にする。
     */
    _hasUnlinkedSubscription: function(cart, subVariantId, sellingPlanId) {
      var linkedIds = this._getLinkedSubIds(cart);
      return cart.items.some(function(item) {
        return item.selling_plan_allocation
          && String(item.selling_plan_allocation.selling_plan.id) === String(sellingPlanId)
          && String(item.variant_id) === String(subVariantId)
          && linkedIds.indexOf(String(subVariantId)) === -1;
      });
    },

    /**
     * 初期費用行（_initial_fee_for）から紐付けられている月額バリアントID。
     * 紐付けの有無だけを見る（数量は見ない）。初期費用が足りているかの判定は _getSubscriptionsWithoutFee を使う
     */
    _getLinkedSubIds: function(cart) {
      return cart.items.filter(function(item) {
        return item.properties && item.properties[PROPERTY_KEY];
      }).map(function(item) {
        return String(item.properties[PROPERTY_KEY]);
      });
    },

    /**
     * 初期費用が必要な月額行（data-cart-fee-map にあるもの）のうち、紐付いた初期費用の数量の合計が月額の数量に足りない月額バリアントID。
     * 1契約につき初期費用1回のため、数で判定する（main-cart.liquid の has_subscription_without_fee と同じ基準）。
     * 参照先の初期費用バリアントが削除されている（マップの値が null）月額も含む
     */
    _getSubscriptionsWithoutFee: function(cart) {
      var feeMap = this._getCartFeeMap();
      if (!feeMap) return [];
      var subQuantities = this._subscriptionQuantities(cart);
      var feeQuantities = {};
      cart.items.forEach(function(item) {
        if (!(item.properties && item.properties[PROPERTY_KEY])) return;
        var linkedId = String(item.properties[PROPERTY_KEY]);
        feeQuantities[linkedId] = (feeQuantities[linkedId] || 0) + item.quantity;
      });
      return cart.items.filter(function(item) {
        var id = String(item.variant_id);
        return item.selling_plan_allocation
          && Object.prototype.hasOwnProperty.call(feeMap, id)
          && (feeQuantities[id] || 0) < subQuantities[id];
      }).map(function(item) {
        return String(item.variant_id);
      });
    },

    /**
     * main-cart.liquid がチェックアウトを止めている原因（未紐付けの初期費用行・初期費用の無い月額行）が、
     * 表示中（再読込時点）の状態から変わったか
     */
    _isCheckoutBlockChanged: function(cart) {
      var feeEl = document.querySelector('[data-unlinked-initial-fee-variants]');
      var subEl = document.querySelector('[data-subscription-without-fee-variants]');
      var renderedFeeIds = feeEl ? feeEl.getAttribute('data-unlinked-initial-fee-variants').split(',') : [];
      var renderedSubIds = subEl ? subEl.getAttribute('data-subscription-without-fee-variants').split(',') : [];

      // 紐付けの無い初期費用行は、JS からは初期費用商品か判別できないため、表示中のものが残っているかだけを見る
      var feeIds = cart.items.filter(function(item) {
        return renderedFeeIds.indexOf(String(item.variant_id)) !== -1
          && !(item.properties && item.properties[PROPERTY_KEY]);
      }).map(function(item) {
        return String(item.variant_id);
      });

      return !sameIds(feeIds, renderedFeeIds)
        || !sameIds(this._getSubscriptionsWithoutFee(cart), renderedSubIds);
    },

    /**
     * カート API に JSON を POST する。エラー応答（4xx 等）は reject する。
     */
    _postJSON: function(url, body) {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(r) {
        return r.json().then(function(result) {
          if (!r.ok || result.status) {
            throw new Error(result.description || result.message || ('HTTP ' + r.status));
          }
          return result;
        });
      });
    },

    /**
     * 完全な整合性チェック（DOM の fee-map 使用 = 不足追加も含む）
     */
    _ensureConsistencyFull: function(cart, cartFeeMap) {
      var feeItems = [];
      var subscriptionVariantIds = [];
      var changes = [];

      cart.items.forEach(function(item) {
        if (item.properties && item.properties[PROPERTY_KEY]) {
          feeItems.push(item);
        }
        if (item.selling_plan_allocation) {
          subscriptionVariantIds.push(String(item.variant_id));
        }
      });

      // 1. 孤立した初期費用を削除（付随するアドオン行も）
      var self = this;
      feeItems.forEach(function(feeItem) {
        var linkedId = feeItem.properties[PROPERTY_KEY];
        if (subscriptionVariantIds.indexOf(String(linkedId)) === -1) {
          changes.push({ key: feeItem.key, quantity: 0, action: 'remove_orphan' });
          changes = changes.concat(self._addonRemovals(cart, feeItem));
        }
      });

      // 2. 数量補正（初期費用は月額の数量と同じ数だけ必要）
      var subQuantities = this._subscriptionQuantities(cart);
      changes = changes.concat(this._quantityFixes(cart, feeItems, subQuantities));

      // 3. 初期費用の無い月額に初期費用を用意する
      // 対応する初期費用行が紐付け無しで既にある場合（初期費用商品の subscription_product 未設定で月額補完されない場合など）は、
      // 追加すると二重請求になるため、その行に紐付けだけを付ける。紐付けば main-cart.liquid のチェックアウト停止も解除される。
      var existingFeeVariantIds = cart.items.map(function(item) {
        return String(item.variant_id);
      });
      var linkedSubIds = this._getLinkedSubIds(cart);
      var linkingFeeKeys = [];

      Object.keys(cartFeeMap).forEach(function(subVariantId) {
        if (subscriptionVariantIds.indexOf(subVariantId) === -1) return;
        if (linkedSubIds.indexOf(subVariantId) !== -1) return;

        // 参照先の初期費用バリアントが削除されている → 追加できないため、チェックアウトを止めたままにする（main-cart.liquid）
        if (cartFeeMap[subVariantId] === null) {
          console.error('[InitialFeeManager] 月額バリアント ' + subVariantId +
            ' の初期費用バリアント（custom.initial_fee_variant_id）が見つかりません。メタフィールドを確認してください');
          return;
        }

        var expectedFeeVariantId = String(cartFeeMap[subVariantId]);
        var unlinkedFee = cart.items.filter(function(item) {
          return String(item.variant_id) === expectedFeeVariantId
            && !(item.properties && item.properties[PROPERTY_KEY])
            && linkingFeeKeys.indexOf(item.key) === -1;
        })[0];
        if (unlinkedFee) {
          linkingFeeKeys.push(unlinkedFee.key);
          var properties = {};
          Object.keys(unlinkedFee.properties || {}).forEach(function(k) {
            properties[k] = unlinkedFee.properties[k];
          });
          properties[PROPERTY_KEY] = subVariantId;
          changes.push({ key: unlinkedFee.key, quantity: subQuantities[subVariantId], properties: properties, action: 'link_existing' });
          return;
        }

        // 他の月額に紐付いた同じ初期費用行がある場合も、重複追加しない
        if (existingFeeVariantIds.indexOf(expectedFeeVariantId) === -1) {
          changes.push({
            add: true,
            feeVariantId: expectedFeeVariantId,
            subscriptionVariantId: subVariantId,
            quantity: subQuantities[subVariantId],
            action: 'add_missing'
          });
        }
      });

      if (changes.length > 0) {
        this._applyChanges(changes);
      }
    },

    // ================================================================
    //  共通ユーティリティ
    // ================================================================

    _getFeeMapFromProductForm: function() {
      var el = document.querySelector('[data-initial-fee-map]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); }
      catch (e) { return null; }
    },

    /**
     * 初期費用行に付随する Easify（組立オプション等）のアドオン行の削除指示を返す。
     * 親行の _tpo_add_on_keys にアドオン行の _tpo_add_on_key が含まれるものが対象。
     */
    _addonRemovals: function(cart, parentItem) {
      var addOnKeys = parentItem.properties && parentItem.properties._tpo_add_on_keys;
      if (!addOnKeys) return [];
      return cart.items.filter(function(item) {
        var key = item.properties && item.properties._tpo_add_on_key;
        return key && String(addOnKeys).indexOf(key) !== -1;
      }).map(function(item) {
        return { key: item.key, quantity: 0, action: 'remove_addon' };
      });
    },

    _getCartSubscriptionMap: function() {
      var els = document.querySelectorAll('[data-initial-fee-subscription-map]:not([data-form-id])');
      if (els.length === 0) return null;
      var merged = {};
      Array.prototype.forEach.call(els, function(el) {
        try {
          var map = JSON.parse(el.textContent);
          Object.keys(map).forEach(function(k) { merged[k] = map[k]; });
        } catch (e) {}
      });
      return merged;
    },

    _getCartFeeMap: function() {
      var el = document.querySelector('[data-cart-fee-map]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); }
      catch (e) { return null; }
    },

    /**
     * 月額バリアントごとの数量の合計（定期購入の行のみ）
     */
    _subscriptionQuantities: function(cart) {
      var quantities = {};
      cart.items.forEach(function(item) {
        if (!item.selling_plan_allocation) return;
        var id = String(item.variant_id);
        quantities[id] = (quantities[id] || 0) + item.quantity;
      });
      return quantities;
    },

    /**
     * 初期費用行の数量を、紐付く月額の数量に合わせる変更指示を返す（1契約につき初期費用1回）。
     * 組立オプション等で同じ月額に初期費用行が複数ある場合は、行ごとではなく合計を月額の数量に合わせる。
     * 増やすときは最後の行に足し、減らすときは最後の行から減らす（0 になる行は付随するアドオン行も削除）。
     * 紐付く月額が無い行は孤立削除の対象なのでここでは扱わない。
     */
    _quantityFixes: function(cart, feeItems, subQuantities) {
      var self = this;
      var groups = {};
      feeItems.forEach(function(feeItem) {
        var linkedId = String(feeItem.properties[PROPERTY_KEY]);
        (groups[linkedId] = groups[linkedId] || []).push(feeItem);
      });

      var changes = [];
      Object.keys(groups).forEach(function(linkedId) {
        var expected = subQuantities[linkedId];
        if (!expected) return;
        var lines = groups[linkedId];
        var total = lines.reduce(function(sum, item) { return sum + item.quantity; }, 0);
        var diff = expected - total;
        if (diff > 0) {
          var last = lines[lines.length - 1];
          changes.push({ key: last.key, quantity: last.quantity + diff, action: 'fix_quantity' });
        }
        for (var i = lines.length - 1; diff < 0 && i >= 0; i--) {
          var quantity = Math.max(lines[i].quantity + diff, 0);
          diff += lines[i].quantity - quantity;
          changes.push({ key: lines[i].key, quantity: quantity, action: 'fix_quantity' });
          if (quantity === 0) {
            changes = changes.concat(self._addonRemovals(cart, lines[i]));
          }
        }
      });
      return changes;
    },

    /**
     * 初期費用をカートに追加（既にあれば合計を月額の数量に合わせる）
     */
    _addFeeIfNeeded: function(subscriptionVariantId, feeVariantId) {
      var self = this;
      theme.cart.getCart().then(function(cart) {
        var subQuantities = self._subscriptionQuantities(cart);
        var linkedFeeItems = cart.items.filter(function(item) {
          return item.properties
            && String(item.properties[PROPERTY_KEY]) === String(subscriptionVariantId);
        });

        if (linkedFeeItems.length > 0) {
          var changes = self._quantityFixes(cart, linkedFeeItems, subQuantities);
          if (changes.length > 0) self._applyChanges(changes);
          return;
        }

        var data = {
          id: feeVariantId,
          quantity: subQuantities[String(subscriptionVariantId)] || 1,
          properties: {}
        };
        data.properties[PROPERTY_KEY] = String(subscriptionVariantId);

        self._postJSON(theme.routes.cartAdd, { items: [data] })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function(err) {
          console.warn('[InitialFeeManager] Error adding fee to cart:', err);
        });
      });
    },

    /**
     * 変更を順次適用 → cart:build で再描画
     * 戻り値: 1件でも反映できたら true になる Promise
     */
    _applyChanges: function(changes) {
      var self = this;
      self._isApplyingChanges = true;
      var changed = false;
      var chain = Promise.resolve();

      changes.forEach(function(change) {
        chain = chain.then(function() {
          var request;
          if (change.add) {
            var data = {
              id: parseInt(change.feeVariantId),
              quantity: change.quantity,
              properties: {}
            };
            data.properties[PROPERTY_KEY] = String(change.subscriptionVariantId);
            request = self._postJSON(theme.routes.cartAdd, { items: [data] });
          } else {
            var body = { id: change.key, quantity: change.quantity };
            if (change.properties) body.properties = change.properties;
            request = self._postJSON(theme.routes.cartChange, body);
          }
          // 1件の失敗（在庫切れ等）で残りの変更を止めない
          return request.then(function() {
            changed = true;
          }).catch(function(err) {
            console.warn('[InitialFeeManager] Failed to apply ' + change.action + ':', err);
          });
        });
      });

      return chain.then(function() {
        // 1件も反映されなければカートは変わっていない。再読込すると同じ変更の適用→再読込を繰り返すため何もしない
        if (!changed) {
          self._isApplyingChanges = false;
          return false;
        }
        // カートページでは cart:build（cart.ajax）だと同意欄が消え、アプリのアドオン行も残るため再読込する
        if (document.getElementById('CartPageForm')) {
          window.location.reload();
          return true;
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(function() { self._isApplyingChanges = false; }, 2000);
        return true;
      }).catch(function(err) {
        self._isApplyingChanges = false;
        console.warn('[InitialFeeManager] Consistency check error:', err);
        return false;
      });
    }
  };

  console.log('[InitialFeeManager] JS loaded');

  // theme.js の読み込みを待つ
  function waitForTheme(callback) {
    if (typeof theme !== 'undefined' && theme.cart && theme.routes) {
      console.log('[InitialFeeManager] theme ready immediately');
      callback();
    } else {
      console.log('[InitialFeeManager] waiting for theme...');
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        if (typeof theme !== 'undefined' && theme.cart && theme.routes) {
          clearInterval(interval);
          console.log('[InitialFeeManager] theme ready after', attempts * 100, 'ms');
          callback();
        } else if (attempts > 50) {
          clearInterval(interval);
          console.warn('[InitialFeeManager] theme object not found after 5s');
        }
      }, 100);
    }
  }

  waitForTheme(function() {
    console.log('[InitialFeeManager] init starting');
    InitialFeeManager.init();
    console.log('[InitialFeeManager] init complete, listeners registered');
  });
})();
